// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IUuOc","largestCol":"styles_largestCol__3wImW","smallestCol":"styles_smallestCol__ZKkcH"};